import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "text-sm text-gray-900 whitespace-nowrap px-6 py-5" }
const _hoisted_2 = { class: "text-sm text-gray-900 whitespace-nowrap px-6 py-5" }
const _hoisted_3 = { class: "text-sm text-gray-900 whitespace-nowrap px-6 py-5 w-6/12" }
const _hoisted_4 = { class: "text-sm text-gray-900 whitespace-nowrap px-6 py-5" }
const _hoisted_5 = { class: "text-sm text-gray-900 whitespace-nowrap px-6 py-5" }

import DataTable from '@/components/DataTable.vue';
import PagePagination from '@/components/PagePagination.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ActivityLogsTable',
  props: {
    logs: {
        type: Object,
        default: () => ({})
    }
},
  emits: ["fetchIndex"],
  setup(__props, { emit: __emit }) {



const emit = __emit

const fetchIndex = () => {
    emit("fetchIndex");
}

const headers: { text: string }[] = [
    { text: 'ID' },
    { text: 'Subject' },
    { text: 'Description' },
    { text: 'Caused By' },
    { text: 'Date Created'}
];


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(DataTable, {
      noAction: "",
      headers: headers,
      count: __props.logs?.data?.length
    }, {
      body: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.logs?.data, (item, key) => {
          return (_openBlock(), _createElementBlock("tr", { key: key }, [
            _createElementVNode("td", _hoisted_1, [
              _createElementVNode("p", null, _toDisplayString(item.id), 1)
            ]),
            _createElementVNode("td", _hoisted_2, _toDisplayString(item.event), 1),
            _createElementVNode("td", _hoisted_3, _toDisplayString(item.description), 1),
            _createElementVNode("td", _hoisted_4, _toDisplayString(item.causer_name), 1),
            _createElementVNode("td", _hoisted_5, _toDisplayString(item.created_at), 1)
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["count"]),
    _createVNode(PagePagination, {
      class: "mb-6",
      items: __props.logs,
      onNextPage: fetchIndex
    }, null, 8, ["items"])
  ]))
}
}

})